module.exports = __webpack_public_path__ + "media/images/icons/star-3-red-d59db3f81b50f8e6b99c212143b714f8.svg";